import useCaseStudies from "@/hooks/useCaseStudies";
import { Buttons } from "@/ui/Buttons";
import { Carousel } from "@/ui/Carousel";
import { CaseStudyCard } from "@/ui/CaseStudyCard";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import classes from "./styles.module.scss";

// Most slides visible at once (the 1200px+ breakpoint below).
const MAX_VISIBLE = 3;

export default function ({
  className = "py-5 py-md-6",
  title = "Case Studies",
  description = "<p>See how we have helped organisations like yours find the people they need.</p>",
  buttons = [{ label: "View all Case Studies", url: "/case-studies/", variant: "blue" }],
  // filter the CMS "Case Studies" category, e.g. tags: "Biotechnology"
  tags = null,
  names = null,
  limit = 12,
  // arrows only by default; true (or a Swiper autoplay config) scrolls it by itself
  autoplay = false,
  prefix,
  EditableText,
  EditableHtml,
  theme = "light",
}) {
  const caseStudies = useCaseStudies({ tags, names, limit });

  // Nothing tagged for this page yet, so leave no empty block behind.
  if (!caseStudies.length) {
    return null;
  }

  // Only loop and show arrows when there is more than fits on screen.
  const scrollable = caseStudies.length > MAX_VISIBLE;

  return (
    <div className={cn(className, classes.CaseStudiesCarousel)} data-bs-theme={theme}>
      <Container fluid className="pe-0">
        <Row>
          <Col xs={12} md={3} className="mb-4 mb-md-0 ps-md-5 text-center text-md-start">
            <EditableText path="title" tag="h2">
              {title}
            </EditableText>
            <EditableHtml path="description">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </EditableHtml>
            <Buttons className="mt-md-5 justify-content-md-start" buttons={buttons} />
          </Col>
          <Col xs={12} md={9}>
            <Carousel
              elementKey={prefix}
              navigation={scrollable}
              loop={scrollable}
              autoplay={
                autoplay === true
                  ? { delay: 5000, pauseOnMouseEnter: true, disableOnInteraction: true }
                  : autoplay
              }
              spaceBetween={16}
              slidesPerView={1.1}
              breakpoints={{
                480: { slidesPerView: 1.4 },
                768: { slidesPerView: 1.6 },
                992: { slidesPerView: 2.2 },
                1200: { slidesPerView: MAX_VISIBLE },
                1400: { slidesPerView: MAX_VISIBLE },
              }}
              items={caseStudies.map((caseStudy) => (
                <CaseStudyCard key={caseStudy.id} {...caseStudy} />
              ))}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
